module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/careers.4e54c5f28dcf460fefb2b7f6da46c98c.jpg";